import { Component, EventEmitter, Input, IterableDiffers, Output, ChangeDetectionStrategy } from '@angular/core';
import { ListViewColumnFactory } from '../../../service/factory/list-view-column-factory.service';
import { ListViewBase } from '../list-view.base';
import { LanguageService } from '../../../service/language.service';
import { AstralButtonSize } from '../../astral-components/astral-button/astral-button.component';

@Component({
    selector: 'app-popup-list-view',
    templateUrl: './popup-list-view.component.html',
    styleUrls: ['./popup-list-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PopupListViewComponent<TSource = any> extends ListViewBase<TSource> {
  constructor(columnFactory: ListViewColumnFactory, languageService: LanguageService, iterableDiffers: IterableDiffers) {
    super(columnFactory, languageService, iterableDiffers);
  }

  @Output() buttonClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() nextPage: EventEmitter<void> = new EventEmitter<void>();
  @Input() buttonSize: AstralButtonSize;
  @Input() buttonText: string;

  onButtonClicked(event: any) {
    this.buttonClick.emit({ event: event });
  }

  onScroll(e: any): void {
    const tableContainer = e.target;
    const atBottom = tableContainer.scrollHeight - tableContainer.scrollTop === tableContainer.clientHeight;

    if (atBottom) {
      this.nextPage.emit();
    }
  }
}
